import React from 'react';

export const NotFound: React.FC = () => {
  return (
    <div className="bg-whiteYellow flex items-center justify-center h-screen">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-4">
          404 - ページが見つかりません
        </h2>
        <p>指定されたURLは存在しません。</p>
      </div>
    </div>
  );
};
